<template>
  <div class="tech-evaluation-platform">
   <lunbo></lunbo>
    <section class="intro-section">
      <div class="container">
        <PingJia></PingJia>
        <div @click="toRegister" class="apply-cta">
          <a href="#" class="apply-btn">评 价 申 请 入 口</a>
        </div>
      </div>
    </section>

    <!-- 评价报告作用 -->
    <pingjiaBaogao></pingjiaBaogao>
     

    <!-- 评价工作流程 -->
    <liuCheng></liuCheng>
     
  </div>
</template>

<script>
  import PingJia from './PingJia.vue';
  import lunbo from '../../components/lunbo.vue';
  import liuCheng from './liuCheng.vue';
  import pingjiaBaogao from './pingjiaBaogao.vue';
export default {
  name: 'TechEvaluationPlatform',
  props: {},
  components: {
    PingJia,
    lunbo,
    liuCheng,
    pingjiaBaogao
  },
  data() {
    return {}
  },
  methods: {
    toRegister(){
       window.location.href = this.$toPathUrl + "login/user";; 
    }
  }
}
</script>

<style scoped>
/* 基础样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  margin: 0 auto;
  padding: 30px;
}

/* 头部横幅 */
.hero-section {
  background: #4169e1;
  color: white;
  padding: 60px 0;
  text-align: center;
  height: 400px;
  display: flex;
  align-items: center;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 30px;
  line-height: 1.2;
  color: #fff;
  margin-bottom: 40px;
}

.hero-tags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
}

.tag-item {
  font-size: 1.2rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
}

/* 机构简介与数据概览 */
.intro-section {
  background: #fff;
}

.data-stats {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 30px;
}

.stat-item {
  text-align: center;
  min-width: 120px;
}

.stat-number {
  font-size: 1.8rem;
  font-weight: 700;
  color: #4169e1;
  margin-bottom: 0.5rem;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
}

.agency-intro {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.section-subtitle {
  color: #4169e1;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.intro-text {
  color: #666;
  line-height: 1.6;
}

.apply-cta {
  text-align: center;
  margin: 0 auto;
  margin-top: 30px;
  max-width: 1400px;
}

.apply-btn {
  display: inline-block;
  background: #ff7f00;
  color: white;
  padding: 1.8rem 3rem;
  font-size: 2rem;
  font-weight: 600;
  border-radius: 4px;
  text-decoration: none;
  width: 100%;
  transition: background 0.3s;
}

.apply-btn:hover {
  background: #e67300;
}

/* 评价报告作用 */
.benefits-section {
  padding: 60px 0;
  background: white;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  color: #333;
  margin-bottom: 40px;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.benefit-card {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: transform 0.3s, box-shadow 0.3s;
}

.benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.card-title {
  color: #4169e1;
  font-size: 1.2rem;
  margin-bottom: 0.8rem;
}

.card-desc {
  color: #666;
  line-height: 1.5;
  font-size: 0.95rem;
}

/* 评价工作流程 */
.process-section {
  padding: 60px 0;
  background: #f8f9fa;
}

.process-timeline {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.process-timeline::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background: #4169e1;
  transform: translateY(-50%);
  z-index: 0;
}

.process-step {
  background: white;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
  min-width: 180px;
  margin: 1rem 0.5rem;
  position: relative;
  z-index: 1;
  transition: transform 0.3s;
}

.process-step:hover {
  transform: translateY(-5px);
}

.step-number {
  background: #4169e1;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin: 0 auto 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.step-title {
  color: #333;
  font-size: 0.95rem;
  font-weight: 500;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-tags {
    gap: 1rem;
  }
  
  .tag-item {
    font-size: 1rem;
  }
  
  .process-timeline {
    flex-direction: column;
  }
  
  .process-timeline::before {
    top: 0;
    left: 50%;
    bottom: 0;
    width: 2px;
    height: 100%;
    transform: translateX(-50%);
  }
}

@media (max-width: 576px) {
  .hero-title {
    font-size: 1.8rem;
  }
  
  .benefits-grid {
    grid-template-columns: 1fr;
  }
}
</style>